export function cn(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(" ");
}

/**
 * Guards against JS floating-point drift (e.g. a number-input spinner landing on
 * 0.9999999996 instead of 1, which then compounds into cents-level errors once
 * multiplied through a cost/quantity calculation). Round any money or quantity
 * value to a fixed precision before displaying or sending it to the backend.
 */
export function roundTo(value: number, decimals: number): number {
  const f = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * f) / f;
}